import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Branded = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 25' {...rest}>
    {type === 'stroke' ? (
      <>
        <path
          d='M20.288 4.05a2.75 2.75 0 0 0-3.889 0l-4.5 4.5a2.75 2.75 0 0 0-.805 1.944v2.172c0 .414.336.75.75.75h2.171c.73 0 1.43-.29 1.945-.806l4.5-4.5a2.75 2.75 0 0 0 0-3.889z'
          fill='currentColor'
        />
        <path
          d='M5.844 11.916a2.75 2.75 0 1 0 0 5.5h10.5a1.25 1.25 0 0 1 0 2.5h-4.5a.75.75 0 1 0 0 1.5h4.5a2.75 2.75 0 0 0 0-5.5h-10.5a1.25 1.25 0 1 1 0-2.5h2.5a.75.75 0 0 0 0-1.5z'
          fill='currentColor'
        />
      </>
    ) : (
      <>
        <path
          d='M20.288 4.05a2.75 2.75 0 0 0-3.889 0l-4.5 4.5a2.75 2.75 0 0 0-.805 1.944v2.172c0 .414.336.75.75.75h2.171c.73 0 1.43-.29 1.945-.806l4.5-4.5a2.75 2.75 0 0 0 0-3.889z'
          fill='currentColor'
        />
        <path
          d='M5.844 11.916a2.75 2.75 0 1 0 0 5.5h10.5a1.25 1.25 0 0 1 0 2.5h-4.5a.75.75 0 1 0 0 1.5h4.5a2.75 2.75 0 0 0 0-5.5h-10.5a1.25 1.25 0 1 1 0-2.5h2.5a.75.75 0 0 0 0-1.5z'
          fill='currentColor'
        />
      </>
    )}
  </IconBase>
);
